import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Devices Online
 */
const devicesOnline = buildAsyncStatReducer({
    key: Metrics.DEVICES_ONLINE,
    types: {
        request: Types.DASHBOARD_DEVICES_ONLINE.request,
        success: Types.DASHBOARD_DEVICES_ONLINE.success,
        failure: Types.DASHBOARD_DEVICES_ONLINE.failure,
    },
    transform: (state, { payload }) => {
        const { online, offline } = payload || {}
        return { online, offline }
    },
})

/**
 * Devices Types
 */
const devicesTypes = buildAsyncStatReducer({
    key: Metrics.DEVICES_TYPES,
    types: {
        request: Types.DASHBOARD_DEVICES_TYPES.request,
        success: Types.DASHBOARD_DEVICES_TYPES.success,
        failure: Types.DASHBOARD_DEVICES_TYPES.failure,
    },
    transform: (state, { payload }) => {
        const { total, types } = payload || {}
        return { total, types }
    },
})

const devicesReducers = [devicesOnline, devicesTypes]

export default devicesReducers
